import { AgGridReact } from "ag-grid-react";
import Cookies from "js-cookie";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { FetchDataTypes } from "../../api/api";
import { Grid, GridApi, GridReadyEvent } from "ag-grid-community";
import { currencyFormat, formateDataPrec } from "../../utils/types";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import _ from "lodash";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { BASE_URL, API_KEY } from "../../api/api"

export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

const UpdateTargets = () => {
  const dataGridRef = useRef<AgGridReact<IOlympicData>>(null);
  const [rowData, setRowData] = useState<any>();
  const [newTarger, setNewTarget] = useState<any>();
  const [first, setfirst] = useState([]);
  const [gridApi, setGridApi] = React.useState<GridApi>();
  const [category, setCategory] = useState("");
  const [temp, setTemp] = useState<number[]>([]);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [totalNewTarget, setTotalNewTarget] = useState(0);
  const [hasError, setHasError] = useState(false);
  function newTarget(props: any) {
    return (
      <input
        type="number"
        className="form-control form-control--small m-auto"
        value={newTarger}
        onChange={(e) => {
          // const inputValue = [...newTarger]
          // inputValue[props.rowIndex] = e.target.value

          props.api.forEachNode(function (node: any) {
            console.log(node.data.newTarget);
          });
          props?.node?.setDataValue("newTarget", e.target.value);
          //setNewTarget(e.target.value)}
        }}
      />
    );
  }

  useEffect(() => {
    let items: any[] = [];

    gridApi?.forEachNode(function (node: any) {
      items.push(node.data);
    });
  }, [first, gridApi, newTarger]);

  const defColumnDefs = useMemo(
    () => ({
      sortable: true,
      //flex:1
    }),
    []
  );

  
  function formateAsPercent(num: any) {
    return new Intl.NumberFormat("default", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num / 100);
  }
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("RebalanceData", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setRowData(response);
      });
  }, []);

  function handleChange(e: any, index: number) {
    const newValue = [...temp];
    newValue[index] = e.target.value;
    setCategory(e.target.value);
    setTemp(newValue);
  }

  useEffect(() => {
    let totalSum = _.sum(
      temp.map((i) => {
        if (i === undefined) {
          return 0;
        } else {
          return Number(i);
        }
      })
    );
    console.log(totalSum);

    if (totalSum >= 101) {
      setShowErrorMsg(true);
    } else {
      setShowErrorMsg(false);
    }
  }, [temp]);

  useEffect(() => {
    if (rowData && rowData.length > 0) {
      let newTargetTotal = 0;
      rowData.forEach((rowData:any) => {
        if (rowData.newTarget !== '' && !isNaN(Number(rowData.newTarget))) {
          newTargetTotal += Number(rowData.newTarget);
        }
      });
      setTotalNewTarget(newTargetTotal);
    }
  }, [rowData]);

  useEffect(() => {
    setHasError(totalNewTarget > 100);
  }, [totalNewTarget]);

  const handleNewTargetChange = (e:any, index:any) => {
    const { value } = e.target;
    const newRows = [...rowData];
    newRows[index].newTarget = value;
    setRowData(newRows);
  };
  const fetchData = () => {
    FetchDataTypes("RebalanceData", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setRowData(response);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };
  const handleSubmit = () => {
    // Construct the payload
    const payload = rowData.map((rowData:any) => {
      return {
        fundID: rowData.fundID,
        newTarget: rowData.newTarget !== '' ? Number(rowData.newTarget) : undefined,
      };
    });
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${Cookies.get("newJwt")}`);
    myHeaders.append("Content-Type", "application/json");
    // Make the PUT request to the server
    fetch(`${BASE_URL}/${API_KEY}/api/rebalance/participants/2`, {
      method: 'PUT',
      headers: myHeaders,
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (response.ok) {
          console.log('Targets updated successfully!');
          fetchData();
        } else {
          console.error('Error updating targets:', response.statusText);
        }
      })
      .catch((error) => {
        console.error('Error updating targets:', error);
      });
  };
  return (
    <div className="mt-4">
      <div className="card mr-2 shadow-none position-relative top-4">
        <div className="col-sm-3 w-100 py-3 justify-content-between tableFilters">
          <h5 className="card-title float-start">Update Targets</h5>
        </div>
        {showErrorMsg && showErrorMsg ? (
          <div
            className="alert alert-danger alert-dismissible position-absolute statusAlert"
            role="alert"
          >
            <div className="alert-message">
              Total Target % should be equal to 100%, Please enter/adjust the
              New Target %
            </div>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        ) : null}
        {hasError && (
        <div
        className="alert alert-danger alert-dismissible position-absolute statusAlert"
        role="alert"
      >
        <div className="alert-message">
          Total Target % should be equal to 100%, Please enter/adjust the
          New Target %
        </div>
        <button
          type="button"
          className="btn-close btn-close-white"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
      )}
        <div className="card-body p-0">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink row" style={{height: '580px'}}>
                {/* <div
                  className="ag-theme-alpine"
                  style={{
                    height: "600px",
                    width: "100%",
                  }}
                >
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={columns}
                    defaultColDef={defColumnDefs}
                    onGridReady={onGridReady}
                    animateRows={true}
                    popupParent={document.body}
                  ></AgGridReact>
                </div> */}

                <table
                  id="UpdateTargets"
                  className="table table-striped my-0 table-fixed"
                  style={{ height: "550px" }}
                >
                  <thead>
                    <tr style={{ height: "42px", verticalAlign: "middle" }}>
                      <th className="text-Start ">Fund</th>

                      <th className="d-none d-xl-table-cell text-end ">
                        Balances
                      </th>
                      <th className="d-none d-xl-table-cell text-end ">
                        Actual %
                      </th>
                      <th className="d-none d-xl-table-cell text-end ">
                        Target %
                      </th>
                      <th className="d-none d-xl-table-cell text-start ">
                        New Target %
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ height: "inherit" }}>
                    {rowData &&
                      rowData?.map((e: any, index: any) => {
                        return (
                          <tr key={index}>
                            <td className="text-start">{e.fundName}</td>
                            <td className="d-none d-xl-table-cell text-end ">
                              {e.marketValue >= 0 ? (
                                <>
                                  {e.marketValue === null
                                    ? "NA"
                                    : "$" + currencyFormat(e.marketValue)}
                                </>
                              ) : (
                                <>
                                  <span className="text-danger">
                                    {"(" +
                                      "$" +
                                      currencyFormat(e.marketValue).slice(1) +
                                      ")"}
                                  </span>
                                </>
                              )}
                            </td>
                            <td className="d-none d-xl-table-cell text-end ">
                              {e.actualPct >= 0 ? (
                                <>
                                  {e.actualPct === null
                                    ? "NA"
                                    : formateAsPercent(e.actualPct)}
                                </>
                              ) : (
                                <>
                                  <span className="text-danger">
                                    {"(" +
                                      formateAsPercent(e.actualPct).slice(1) +
                                      ")"}
                                  </span>
                                </>
                              )}
                            </td>
                            <td className="d-none d-xl-table-cell text-end ">
                              {e.targetPct >= 0 ? (
                                <>
                                  {e.targetPct === null
                                    ? "NA"
                                    : formateAsPercent(e.targetPct)}
                                </>
                              ) : (
                                <>
                                  <span className="text-danger">
                                    {"(" +
                                      formateAsPercent(e.targetPct).slice(1) +
                                      ")"}
                                  </span>
                                </>
                              )}
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control w-75"
                                value={e.newTarget}
                                onChange={(e) =>
                                  handleNewTargetChange(e, index)
                                }
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
              <div className="row pt-4">
                <div className="float-end text-end">
                  <button type="button" className="btn btn-link">
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={showErrorMsg ? true : false}
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { UpdateTargets };
